import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake';

@Injectable()
export abstract class FontServable {
  public abstract buildFonts(): pdfMake.FontFaceSet;
}
